import { concat, prop, map, complement } from 'ramda'
import { write, utils } from 'xlsx'
import { notify } from '@/utils/notification'
import { download } from '@/utils/download'
import { Column, isSlot, Params, TableResponse } from '@/components/table'
import JSZip from 'jszip'
import axios from 'axios'
import { createSliceIterator, getFileExtenstion } from '@/utils'

const BOOK_TYPE = 'xlsx'

export const createDownloadExcelHanlder = <T>(
  SHEET: string,
  COLUMNS: Column<T>[],
  getList: (params?: Params | undefined) => Promise<TableResponse<T>>
) => {
  const format = (data: T) => {
    const tmp = data as any
    COLUMNS.filter(complement(isSlot))
      .filter((a: any) => !!a.format)
      .filter((a: any) => tmp[a.prop] !== undefined)
      .map((a: any) => ((data as any)[a.prop] = a.format(tmp[a.prop])))

    return data
  }

  const getFullList = async () => {
    const rows = (await getList({ pageSize: 999999, current: 0 })).rows
    return map(format)(rows)
  }

  const toAoa = (row: any) => COLUMNS.map((col: any) => prop(col.prop, row))

  const downloadExcel = async (data?: T[]) => {
    try {
      notify(`正在下载: ${SHEET}, 请耐心等待`)
      const rows = data || (await getFullList())
      const aoa = concat([COLUMNS.map((a: any) => a.label)], rows.map(toAoa))
      const workbook = utils.book_new()
      workbook.SheetNames[0] = SHEET
      workbook.Sheets[SHEET] = utils.aoa_to_sheet(aoa)
      const file = write(workbook, { type: 'array', bookType: BOOK_TYPE })
      const blob = new Blob([file])
      const hash = new Date().toLocaleString()
      download(blob, `${SHEET}-${hash}.${BOOK_TYPE}`)
    } catch (e) {
      notify('下载失败', e)
    }
  }

  return downloadExcel
}

const DOWNLOAD_LIMIT = 3
const HASH_NAME_THRESHOLD = 3
export const createDownloadPhotoHanlder = <T>(
  name: string,
  getNameValue: (a: T) => string,
  getFileNameValue: (a: T) => string,
  getPhotoValue: (a: T) => string,
  getList: (params?: Params | undefined) => Promise<TableResponse<T>>
) => {
  const getFullList = async () =>
    (await getList({ pageSize: 999999, current: 0 })).rows

  const downloadExcel = async (data?: T[]) => {
    try {
      notify(`正在下载: ${name}, 请耐心等待`)
      const rows = data || (await getFullList())

      const zip = new JSZip()
      for (const slice of createSliceIterator(DOWNLOAD_LIMIT, rows)) {
        await Promise.all(
          slice.map(async (row: T) => {
            const url = getPhotoValue(row)
            const { data } = await axios.get(url, { responseType: 'blob' })
            zip.file(
              `${getFileNameValue(row)}.${getFileExtenstion(url)}`,
              data,
              { base64: true }
            )
          })
        )
      }

      const zipBlob = await zip.generateAsync({ type: 'blob' })

      const hash = rows.map(getNameValue).reduce((prev, cur, index) => {
        if (index === 0) {
          return cur
        } else if (index < HASH_NAME_THRESHOLD) {
          return `${prev}、${cur}`
        } else if (index === HASH_NAME_THRESHOLD) {
          return `${prev}等${rows.length}名`
        } else {
          return prev
        }
      }, '')
      download(zipBlob, `${name}-${hash}.zip`)
    } catch (e) {
      notify('下载失败', e)
    }
  }

  return downloadExcel
}

// legacy
export { createDownloadExcelHanlder as createDownloadHanlder }
